import { Component, ChangeDetectionStrategy, Inject, OnInit } from '@angular/core';
import { SidePanelRef } from '../../shared/features/side-panel/models/side-panel-ref';
import { SIDE_PANEL_CONTEXT } from '../../shared/features/side-panel/tokens/side-panel.tokens';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TrackingsService } from '../../services/tracking.service';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

export enum ExperienceRate {
  tooEasy = 'Muito Fácil',
  easy = 'Fácil',
  medium = 'Médio',
  hard = 'Difícil',
  tooHard = 'Muito Difícil'
}
@Component({
  selector: 'app-checkout-review',
  templateUrl: './checkout-review.component.html',
  styleUrls: ['./checkout-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})


export class CheckoutReviewComponent implements OnInit {
  experienceRateForm: FormGroup;
  currentStep: number = 1;
  totalSteps: number = 3;
  reviewText: string;
  textareaMaxLength: number = 245;
  buttonLabel: string = this.currentStep != 3 ? 'Enviar' : 'Fechar';

  public experienceRateEnum = ExperienceRate;
  public experienceRateKeys = Object.keys(this.experienceRateEnum);

  constructor(
    @Inject(SIDE_PANEL_CONTEXT) public panelRef: SidePanelRef<any>,
    private fb: FormBuilder,
    private tracking: TrackingsService,
  ) { }

  ngOnInit(): void {
    this.experienceRateForm = this.fb.group({
      experienceRate: ['', Validators.required] 
    });
  }
  
  get isLastStep(): boolean {
    return this.currentStep === this.totalSteps;
  }

  nextStep() {
    if(this.currentStep == 1) {
      const selectedKey = this.experienceRateForm.get('experienceRate').value;
      const selectedOption = this.experienceRateEnum[selectedKey]

      this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
        'Product Area Origin': 'Bolsa',
        'Element': 'Botão Enviar',
        'Step': 'User feedback',
        'Scenario': this.panelRef.data.purchase ? 'Compra' : 'Venda a descoberto',
        'Time Responsável': 'Roebling',
        'specificProperties': {
          'Option': selectedOption,
          'Version': 'Checkout antigo',
        },
      });
    }

    if(this.currentStep == 2 && this.reviewText) {
      this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
        'Product Area Origin': 'Bolsa',
        'Element': 'Botão Enviar',
        'Step': 'User feedback',
        'Scenario': this.panelRef.data.purchase ? 'Compra' : 'Venda a descoberto',
        'Time Responsável': 'Roebling',
        'specificProperties': {
          'Option': this.reviewText,
          'Version': 'Checkout antigo',
        },
      });
    }
    
    if(this.currentStep == 3) {
      this.panelRef.dismiss();
    }

    if (!this.isLastStep) {
      this.currentStep++;
    }

  }

  cancel(): void {
    this.panelRef.dismiss();
  }
}